import { getData, putData } from "actions";
import { Breadcrumb, CardContainer, Container } from "components";
import { API_URL_kbSetting } from "constants/api";
import { AuthContext } from "context/AuthContext";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { kbSettingReducers } from "redux/kbSettingSlice";

const KBSettings = () => {
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [number, setNumber] = useState(0);

  const { getKbSettingResult, addKbSettingResult } = useSelector(
    (state) => state.kbSetting
  );

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_kbSetting,
        params,
        { dispatch, redux: kbSettingReducers },
        "GET_KBSETTING"
      );
    },
    [dispatch]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      pagination: number,
    };
    //edit on id 1
    putData(
      `${API_URL_kbSetting}1/`,
      formData,
      { dispatch, redux: kbSettingReducers },
      "ADD_KBSETTING",
      () => {
        fetchData();
      }
    );
  };

  const fetchData = useCallback(() => {
    //get id 1 for setting
    const params = `1/`;
    get(params);
  }, [get]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (addKbSettingResult) {
      fetchData();
    }
  }, [addKbSettingResult, fetchData]);

  useEffect(() => {
    if (getKbSettingResult) {
      setNumber(getKbSettingResult.pagination);
    }
  }, [getKbSettingResult]);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Settings Knowledge Base"}
        excludedPaths={["knowledgebase", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
          Settings Knowledge Base
        </div>
        <form onSubmit={handleSubmit}>
          <div className="m-5 flex flex-col gap-2">
            <label>
              Number of elements to display{" "}
              <span className="text-red-500">*</span>
            </label>
            <input
              id="number"
              type="number"
              value={number}
              onChange={(e) => {
                setNumber(e.target.value);
              }}
              className="p-1 w-full md:w-60 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
          </div>
          <div className="h-14 w-full flex items-center px-5 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="rounded-md text-white py-1.5 w-16 bg-sky-600 hover:bg-sky-800 "
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default KBSettings;
